export default __webpack_public_path__ + "static/media/restapi.bd9fb865.jpg";